module.exports = __webpack_public_path__ + "media/music-success.b35d6ea3.mp3";